import React, { Component } from 'react';
import Order from '../components/Order';

class order extends Component {
    render() {
        return (
            <div class="order">
                <Order /> 
            </div>
        );
    }
}

export default order;